import { connect } from 'react-redux';
import { getAllSlips } from 'Actions/slipActions';
import { getCurrentProject, getCurrentTicket } from 'Actions/ticketActions';
import { getProjects, getUsersInvited } from 'Actions/projectActions';
import Grid from '@material-ui/core/Grid';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import NoSlips from '@material-ui/icons/GridOff';
import React from 'react';

import 'CSS/dashboard-slips.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/demand-supply/demand-supply.scss';

import SlipCard from './../components/SlipCard';
import SubHeaderSlips from './../components/SubHeaders/SealDealSubHeader';
import LuminairesSubHeader from './../components/SubHeaders/LuminairesSubHeader';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import styled from 'styled-components';
import Success from 'Components/Success';

const Test = styled(Grid)`
  height: 100%;
`;

// const Container = styled.div`
//   max-width: 1024px;
// `;

class SealDeal extends React.Component {
  state = {
    anchorEl1: null,
    anchorEl2: null,
    anchorEl3: null,
    sortFirstColumnBy: '',
    orderFirstColumnBy: false,
    sortSecondColumnBy: '',
    orderSecondColumnBy: false,
    sortThirdColumnBy: '',
    orderThirdColumnBy: false,
    sortFourthColumnBy: '',
    orderFourthColumnBy: false,
    slipUpdated: false,
  };

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.props.getProjects();
    this.props.setCurrentProjectId(this.props.match.params.projectId);
    this.props.getCurrentProject(this.props.match.params.projectId);
    this.props.setCurrentTicketId(this.props.match.params.ticketId);
    this.props.getAllSlips(this.props.match.params.ticketId);
    this.props.getCurrentTicket(
      this.props.match.params.projectId,
      this.props.match.params.ticketId
    );
    if (this.props.location.state && this.props.location.state.slipUpdated) {
      this.setState({ slipUpdated: true });
      const state = this.props.history.location.state;
      delete state.slipUpdated;
      this.props.history.replace({ ...history.location, state });
    } else {
      this.setState({ slipUpdated: false });
    }
  }

  // getTicket() {
  //   const projectId = this.props.match.params.projectId;
  //   const ticketId = this.props.match.params.ticketId;
  //   const ticket = this.props.getCurrentTicket(projectId, ticketId);
  // }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      nextProps.getCurrentTicket(
        nextProps.match.params.projectId,
        nextProps.match.params.ticketId
      );
      nextProps.setCurrentTicketId(nextProps.match.params.ticketId);
      nextProps.getAllSlips(nextProps.match.params.ticketId);
    }
  }

  handleOpen = () => {
    this.setState({ newProjectDialogOpen: true });
  };
  resetSlipUpdate = () => {
    this.setState({ slipUpdated: false });
  };

  // handleClose = () => {
  //   this.setState({ newProjectDialogOpen: false });
  // };

  handleClick = (anchorEl, event) => {
    this.setState({ [anchorEl]: event.currentTarget });
  };

  handleClose = anchorEl => {
    this.setState({ [anchorEl]: null });
  };

  sortSlips = (slips, sortBy, order) => {
    if (sortBy === '') {
      return slips;
    }
    slips.sort(function(a, b) {
      if (a[sortBy] < b[sortBy]) {
        return -1;
      }
      if (a[sortBy] > b[sortBy]) {
        return 1;
      }
      return 0;
    });
    if (order) {
      return slips.reverse();
    }
    return slips;
  };

  setSortBy = (colum, sortBy, order) => event => {
    this.setState({ [colum]: sortBy, [order]: !this.state[order] });
  };

  renderSlips = (
    sortFirstColumnBy,
    sortSecondColumnBy,
    sortThirdColumnBy,
    sortFourthColumnBy,
    orderFirstColumnBy,
    orderSecondColumnBy,
    orderThirdColumnBy,
    orderFourthColumnBy
  ) => {
    let slips = [];
    let brokerSlips = [];
    let brokerSlipsCompanyName = [];
    let shortlistedSlips = [];
    let shortlistedSlipsCompanyName = [];
    let selectedSlips = [];
    let selectedSlipsCompanyName = [];
    let archivedSlips = [];
    let archivedSlipsCompanyName = [];

    if (this.props.slips) {
      slips = [...this.props.slips];

      console.log(slips[0]);

      let slipsIds = slips.map(({ id }) => id);

      brokerSlips = slips.filter(
        slip => slip.slipState === 'VIEWED' || slip.slipState === 'NEW'
      );

      brokerSlipsCompanyName = brokerSlips.map(obj => {
        const {
          companyDetailsResponse: { companyName },
        } = obj;
        return {
          ...obj,
          companyName,
        };
      });

      brokerSlipsCompanyName = this.sortSlips(
        brokerSlipsCompanyName,
        sortFirstColumnBy,
        orderFirstColumnBy
      ).map(slip1 => (
        <SlipCard
          slipsIds={slipsIds}
          key={slip1.id}
          slip={slip1}
          ticketId={this.props.match.params.ticketId}
          projectId={this.props.match.params.projectId}
          slipState={slip1.slipState}
        />
      ));

      shortlistedSlips = slips.filter(slip => slip.slipState === 'RESPONDED');
      shortlistedSlipsCompanyName = shortlistedSlips.map(obj => {
        const {
          companyDetailsResponse: { companyName },
        } = obj;
        return {
          ...obj,
          companyName,
        };
      });
      shortlistedSlipsCompanyName = this.sortSlips(
        shortlistedSlipsCompanyName,
        sortSecondColumnBy,
        orderSecondColumnBy
      ).map(slip1 => (
        <SlipCard
          slipsIds={slipsIds}
          key={slip1.id}
          slip={slip1}
          ticketId={this.props.match.params.ticketId}
          projectId={this.props.match.params.projectId}
          slipState={slip1.slipState}
          specSheetCriteria={slip1.specificationSheetValue}
        />
      ));

      selectedSlips = slips.filter(slip => slip.slipState === 'DEAL');
      selectedSlipsCompanyName = selectedSlips.map(obj => {
        const {
          companyDetailsResponse: { companyName },
        } = obj;
        return {
          ...obj,
          companyName,
        };
      });

      selectedSlipsCompanyName = this.sortSlips(
        selectedSlipsCompanyName,
        sortThirdColumnBy,
        orderThirdColumnBy
      ).map(slip1 => (
        <SlipCard
          slipsIds={slipsIds}
          key={slip1.id}
          slip={slip1}
          ticketId={this.props.match.params.ticketId}
          projectId={this.props.match.params.projectId}
          slipState={slip1.slipState}
          specSheetCriteria={slip1.specificationSheetValue}
        />
      ));

      // ARCHVIED SLIPS
      archivedSlips = slips.filter(slip => slip.slipState === 'ARCHIVED');
      archivedSlipsCompanyName = archivedSlips.map(obj => {
        const {
          companyDetailsResponse: { companyName },
        } = obj;
        return { ...obj, companyName };
      });

      archivedSlipsCompanyName = this.sortSlips(
        archivedSlipsCompanyName,
        sortFourthColumnBy,
        orderFourthColumnBy
      ).map(slip => (
        <SlipCard
          slipsIds={slipsIds}
          key={slip.id}
          slip={slip}
          ticketId={this.props.match.params.ticketId}
          projectId={this.props.match.params.projectId}
          slipState={slip.slipState}
          specSheetCriteria={slip.specificationSheetValue}
        />
      ));
    }

    if (brokerSlipsCompanyName.length === 0) {
      brokerSlipsCompanyName = [
        <div key={0} className="no-slips">
          <NoSlips />
          <p className="t-primary-16 u-mrg-top-10">No new luminaires yet</p>
        </div>,
      ];
    }
    if (shortlistedSlipsCompanyName.length === 0) {
      shortlistedSlipsCompanyName = [
        <div key={0} className="no-slips">
          <NoSlips />
          <p className="t-primary-16 u-mrg-top-10">No matches yet</p>
        </div>,
      ];
    }
    if (selectedSlipsCompanyName.length === 0) {
      selectedSlipsCompanyName = [
        <div key={0} className="no-slips">
          <NoSlips />
          <p className="t-primary-16 u-mrg-top-10">
            No selected luminaires yet
          </p>
        </div>,
      ];
    }
    if (archivedSlipsCompanyName.length === 0) {
      selectedSlipsCompanyName = [
        <div key={0} className="no-slips">
          <NoSlips />
          <p className="t-primary-16 u-mrg-top-10">
            No selected luminaires yet
          </p>
        </div>,
      ];
    }

    return (
      <Grid container spacing={16}>
        <Grid item lg={3} md={6} xs={12} className="broker-slips">
          <div className="slips-title broker">
            <div>
              <h3 className="t-secondary-24">Showroom</h3>
              <p className="t-primary-14 c-blue-2">Luminaires</p>
            </div>
            <MoreHoriz onClick={e => this.handleClick('anchorEl1', e)} />
            <Menu
              className="long-menu"
              anchorEl={this.state.anchorEl1}
              open={Boolean(this.state.anchorEl1)}
              onClose={() => this.handleClose('anchorEl1')}
            >
              <div style={{ outline: 'none', paddingLeft: '16px' }}>
                Sort by:
              </div>
              <MenuItem
                key={0}
                onClick={this.setSortBy(
                  'sortFirstColumnBy',
                  'dateCreated',
                  'orderFirstColumnBy'
                )}
              >
                Date
              </MenuItem>
              <MenuItem
                key={1}
                onClick={this.setSortBy(
                  'sortFirstColumnBy',
                  'companyName',
                  'orderFirstColumnBy'
                )}
              >
                Manufacturer Name
              </MenuItem>
            </Menu>
          </div>
          <Grid container className="" spacing={16}>
            {brokerSlipsCompanyName}
          </Grid>
        </Grid>
        <Grid item lg={3} md={6} xs={12} className="seal-slips">
          <div className="slips-title seal">
            <div>
              <h3 className="t-secondary-24">Sift</h3>
              <p className="t-primary-14 c-blue-2">Matches</p>
            </div>
            <MoreHoriz onClick={e => this.handleClick('anchorEl2', e)} />
            <Menu
              className="long-menu"
              anchorEl={this.state.anchorEl2}
              open={Boolean(this.state.anchorEl2)}
              onClose={() => this.handleClose('anchorEl2')}
            >
              <div style={{ outline: 'none', paddingLeft: '16px' }}>
                Sort by:
              </div>
              <MenuItem
                key={4}
                onClick={this.setSortBy(
                  'sortSecondColumnBy',
                  'dateCreated',
                  'orderSecondColumnBy'
                )}
              >
                Date
              </MenuItem>
              <MenuItem
                key={6}
                onClick={this.setSortBy(
                  'sortSecondColumnBy',
                  'companyName',
                  'orderSecondColumnBy'
                )}
              >
                Manufacturer Name
              </MenuItem>
            </Menu>
          </div>
          <Grid container className="" spacing={16}>
            {shortlistedSlipsCompanyName}
          </Grid>
        </Grid>
        <Grid item lg={3} md={6} xs={12} className="deal-slips">
          <div className="slips-title deal">
            <div>
              <h3 className="t-secondary-24">Handshake</h3>
              <p className="t-primary-14 c-blue-2">Selections</p>
            </div>{' '}
            <MoreHoriz onClick={e => this.handleClick('anchorEl3', e)} />
            <Menu
              className="long-menu"
              anchorEl={this.state.anchorEl3}
              open={Boolean(this.state.anchorEl3)}
              onClose={() => this.handleClose('anchorEl3')}
            >
              <div style={{ outline: 'none', paddingLeft: '16px' }}>
                Sort by:
              </div>
              <MenuItem
                key={7}
                onClick={this.setSortBy(
                  'sortThirdColumnBy',
                  'dateCreated',
                  'orderThirdColumnBy'
                )}
              >
                Date
              </MenuItem>
              <MenuItem
                key={9}
                onClick={this.setSortBy(
                  'sortThirdColumnBy',
                  'companyName',
                  'orderThirdColumnBy'
                )}
              >
                Manufacturer Name
              </MenuItem>
            </Menu>
          </div>
          <Test container className="" spacing={16}>
            {selectedSlipsCompanyName}
          </Test>
        </Grid>
        <Grid item lg={3} md={6} xs={12} className="archived-slips">
          <div className="slips-title archived">
            <div>
              <h3 className="t-secondary-24">Archived</h3>
              <p className="t-primary-14 c-blue-2">
                Responses to previous versions
              </p>
            </div>{' '}
            <MoreHoriz onClick={e => this.handleClick('anchorEl3', e)} />
            <Menu
              className="long-menu"
              anchorEl={this.state.anchorEl3}
              open={Boolean(this.state.anchorEl3)}
              onClose={() => this.handleClose('anchorEl3')}
            >
              <div style={{ outline: 'none', paddingLeft: '16px' }}>
                Sort by:
              </div>
              <MenuItem
                key={7}
                onClick={this.setSortBy(
                  'sortFourthColumnBy',
                  'dateCreated',
                  'orderFourthColumnBy'
                )}
              >
                Date
              </MenuItem>
              <MenuItem
                key={9}
                onClick={this.setSortBy(
                  'sortFourthColumnBy',
                  'companyName',
                  'orderFourthColumnBy'
                )}
              >
                Manufacturer Name
              </MenuItem>
            </Menu>
          </div>
          <Test container className="" spacing={16}>
            {archivedSlipsCompanyName}
          </Test>
        </Grid>
      </Grid>
    );
  };

  render() {
    const ticketId = Number(this.props.match.params.ticketId);
    return (
      // Page with tickets
      <Grid item className="flex-dashboard">
        <Success
          open={this.state.slipUpdated}
          message="Submission successful"
          handleClose={this.resetSlipUpdate}
        />
        <SubHeaderSlips
          currentTicket={this.props.currentTicket}
          goBack={() => this.props.history.goBack()}
          ticket={
            this.props.tickets
              ? this.props.tickets.find(ticket => ticket.ticketId === ticketId)
              : null
          }
          projectId={this.props.match.params.projectId}
          ticketId={this.props.match.params.ticketId}
          history={this.props.history}
        />
        <div className="dash-padding">
          {this.renderSlips(
            this.state.sortFirstColumnBy,
            this.state.sortSecondColumnBy,
            this.state.sortThirdColumnBy,
            this.state.sortFourthColumnBy,
            this.state.orderFirstColumnBy,
            this.state.orderSecondColumnBy,
            this.state.orderThirdColumnBy,
            this.state.orderFourthColumnBy
          )}
        </div>
      </Grid>
    );
  }
}
const mapStateToProps = store => {
  return {
    tickets: store.currentProject.tickets,
    currentTicket: store.currentProject.currentTicket,
    slips: store.slips.slips,
  };
};
const mapDispatchToProps = dispatch => ({
  getProjects: () => {
    dispatch(getProjects());
  },
  getCurrentProject: projectId => {
    dispatch(getCurrentProject(projectId));
  },
  getUsersInvited: projectId => {
    dispatch(getUsersInvited(projectId));
  },
  getAllSlips: ticketId => {
    dispatch(getAllSlips(ticketId));
  },
  getCurrentTicket: (projectId, ticketId) => {
    dispatch(getCurrentTicket(projectId, ticketId));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(SealDeal);
